import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { ALIGN_SELF_OPTIONS } from './BoxConstants';
import { toPx } from '../utils/Styles';

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
const Box = styled.div.withConfig({
  displayName: "UIBox__Box",
  componentId: "kva812-0"
})(["align-self:", ";flex-basis:", ";flex-grow:", ";flex-shrink:", ";order:", ";"], props => props.alignSelf && ALIGN_SELF_OPTIONS[props.alignSelf], props => props.basis && toPx(props.basis), props => props.grow, props => props.shrink, props => props.order);
const UIBox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, Object.assign({}, rest, {
    className: cx('private-flex__child', className),
    ref: ref
  }));
});
UIBox.defaultProps = {
  alignSelf: 'auto',
  basis: 'auto',
  grow: 0,
  shrink: 1
};
UIBox.propTypes = {
  alignSelf: PropTypes.oneOf(Object.keys(ALIGN_SELF_OPTIONS)),
  basis: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  grow: PropTypes.number,
  shrink: PropTypes.number,
  order: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['inherit', 'initial', 'unset'])])
};
export default UIBox;